import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  reduce, values, sortBy, each,
  filter, map,
} from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';

import Charts from '../components/Charts';
import {
  getWinLossOpportunities,
  getWinLossCollectorStats,
} from '../../Dashboard/DashboardReducer';
import { getUserCurrentOrganization } from '../../Auth/AuthReducer';

import TopLeaders from '../components/TopLeaders';
import LeaderBoardTable from '../components/SaleRepTable';
import OpportunityModal from '../../Analysic/components/opportunity-modal';
import RequestFeedbackManager from '../../../components/request-feedback-manager';

class FeedbackRequestPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      owners: [],
      selectedOpportunityIds: [],
    };
    this.handleRequestShowDeals = this.handleRequestShowDeals.bind(this);
  }

  componentWillMount() {
    const { opportunities, collectorStats, threshold } = this.props;
    // indexed by owner id
    const indexedOwners = reduce(opportunities, (items, opportunity) => {
      if (opportunity.owner) {
        const ownerId = opportunity.owner_id;
        if (!items[ownerId]) {
          items[ownerId] = {
            ...opportunity.owner,
            owner_id: opportunity.owner.user_id,
            dealCount: 0,
            dealWithFeedbackRequests: 0,
            feedbackRequestsContacts: 0,
            requestedFeedbackPercent: 0,
            dealWithNoRequests: 0,
            rank: 0,
            amount: 0,
            wonAmount: 0,
            wonCount: 0,
            amountWinRate: 0,
            countWinRate: 0,
            isNaughty: false, // auth
            dealWithFeedbackRequestIds: [],
          };
        }
        items[ownerId].dealCount += 1;
        items[ownerId].amount += opportunity.amount || 0;
        if (opportunity.stage === 'Won') {
          items[ownerId].wonAmount += opportunity.amount || 0;
          items[ownerId].wonCount += 1;
        }
        if (opportunity.has_requests) {
          items[ownerId].dealWithFeedbackRequests += 1;
          
          const opportunityId = opportunity.opportunity_id;
          items[ownerId].dealWithFeedbackRequestIds.push(opportunityId);

          if (collectorStats[opportunityId]) {
            items[ownerId].feedbackRequestsContacts += collectorStats[opportunityId].total || 0;
          }
        } else {
          items[ownerId].dealWithNoRequests += 1;
        }
        items[ownerId].requestedFeedbackPercent = items[ownerId].dealCount ? items[ownerId].dealWithFeedbackRequests / items[ownerId].dealCount : 0;
      }
      return items;
    }, {});

    const owners = each(sortBy(values(indexedOwners), owner => -1 * owner.requestedFeedbackPercent), (owner, idx) => {
      if (owner.requestedFeedbackPercent * 100 < threshold) {
        owner.isNaughty = true;
      }
      owner.amountWinRate = owner.amount ? (owner.wonAmount / owner.amount) * 100 : 0;
      owner.countWinRate = owner.dealCount ? (owner.wonCount / owner.dealCount) * 100 : 0;
      owner.rank = idx + 1;
    });
    this.setState({ owners });
  }

  handleRequestShowDeals(filters) {
    const { opportunities } = this.props;
    const selectedOpportunityIds = map(filter(opportunities, filters), 'opportunity_id');
    this.setState({ selectedOpportunityIds });
  }

  render() {
    const { owners, selectedOpportunityIds } = this.state;
    const { threshold, closeDateRange } = this.props;
    return (
      <div>
        <div className="container">
          <TopLeaders owners={owners} requestShowDeals={(ids) => { this.setState({ selectedOpportunityIds: ids }); }} />
        </div>

        <Charts
          closeDateRange={closeDateRange}
          onOpportunitySelect={(ids) => { this.setState({ selectedOpportunityIds: ids }); }}
        />

        <div className="container">
          <LeaderBoardTable
            owners={owners}
            threshold={threshold}
            requestShowDeals={this.handleRequestShowDeals}
          />
        </div>
      
        <OpportunityModal
          opportunityIds={selectedOpportunityIds}
          getOpportunities={getWinLossOpportunities}
          onClose={() => {
            this.setState({ selectedOpportunityIds: [] });
          }}
          tableConfigs={{
            tableName: 'leaderboard-opportunity-table',
          }}
        />
        <RequestFeedbackManager />
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const org = getUserCurrentOrganization(state);
  const threshold = org.naughty_list_threshold || 50;
  return {
    opportunities: getWinLossOpportunities(state),
    collectorStats: getWinLossCollectorStats(state),
    threshold,
  };
}

FeedbackRequestPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  opportunities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  collectorStats: PropTypes.shape({}).isRequired,
  threshold: PropTypes.number.isRequired,
  closeDateRange: PropTypes.arrayOf(PropTypes.instanceOf(moment)),
};

FeedbackRequestPage.defaultProps = {
  closeDateRange: [],
};

FeedbackRequestPage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(FeedbackRequestPage);
